// frontend/src/components/Layout/AdminLayout.tsx
import React from 'react';
import BaseLayout from './BaseLayout';
import { adminLayoutConfig } from './configs/layoutConfigs';

interface AdminLayoutProps {
  children: React.ReactNode;
}

const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {
  return (
    <BaseLayout config={adminLayoutConfig}>
      {children}
    </BaseLayout>
  );
};

export default AdminLayout;